/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import React from 'react';

import { ListeContainer, useListe } from '@mairistem/liste';

import type { Pacs } from '@/types/Pacs';
import ActeListe from './ActeListe';

interface ActeListeContainerProps {
  all?: boolean;
  annee?: number;
  mois?: number;
  typeActe?: string;
  dashboard?: boolean;
  modal?: boolean;
  stats?: boolean;
  assistant?: boolean;
  onSelect?: (item: Partial<Pacs>) => void;
}

const ActeListeContainer = ({
  all,
  annee,
  mois,
  typeActe,
  dashboard = false,
  modal = false,
  stats,
  assistant,
  onSelect,
}: ActeListeContainerProps = {}) => {
  const defaultFilters = {
    ...(all && { all }),
    ...(annee && { annee }),
    ...(mois && { mois }),
    ...(typeActe && { type_acte: typeActe }),
  };

  const [service] = useListe(
    '/api/administres/etat-civil/numerisation-actes/liste',
    defaultFilters,
  );

  return (
    <ListeContainer type="pacs" contains="liste" service={service} perPage={20}>
      <ActeListe
        dashboard={dashboard}
        modal={modal}
        stats={stats}
        assistant={assistant}
        typeActe={typeActe}
        onSelect={onSelect}
      />
    </ListeContainer>
  );
};

export default ActeListeContainer;
